export default __webpack_public_path__ + "static/media/coffee.0ce9b3c3.png";